"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require("@alicd/next/lib/moment");

var _moment2 = _interopRequireDefault(_moment);

exports.getWeekRange = getWeekRange;
exports.normalizeWeekday = normalizeWeekday;
exports.isRangeWeek = isRangeWeek;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getWeekRange(value, dayBase) {
    dayBase = 0 + dayBase;

    var dayNow = (0, _moment2.default)(value).day();
    var tStart = (0, _moment2.default)(value).subtract(dayNow >= dayBase ? dayNow - dayBase : dayNow - dayBase + 7, "days");
    return [tStart, (0, _moment2.default)(tStart).add(6, "days")];
}

function normalizeWeekday(value, day) {
    if (!day) {
        return value;
    } else {
        return getWeekRange(value, 0 + day)[0];
    }
}

function isRangeWeek(value, aWeekDay, dayBase, inclusion) {
    var range = getWeekRange(aWeekDay, 0 + dayBase);
    return (0, _moment2.default)((0, _moment2.default)(value).format('YYYY-MM-DD')).isBetween((0, _moment2.default)(range[0]).format('YYYY-MM-DD'), (0, _moment2.default)(range[1]).format('YYYY-MM-DD'), "day", inclusion);
}

// export function getWeekRange(value, day) {
//     day = 0 + day;
//     return [
//         moment(value).isoWeekday(day),
//         moment(value).isoWeekday(8 - day),
//     ];
// }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/util.js
// module id = 268
// module chunks = 0